export enum DevToolsCommandType {
  TerminateEtlBatch = 'TerminateEtlBatch',
  TerminateLoanValidation = 'TerminateLoanValidation',
  ImportAllIfxLoans = 'ImportAllIfxLoans',
}

export interface DevToolsCommandExecution {
  id: number
  commandType: DevToolsCommandType
  errorMessage: string | null
  executedByUserFullname: string
  executedByUserId: string
  executedOn: string
}
